import * as PropTypes from 'prop-types';
import { allThreatLevelCategories, allThreatLevelNumbers } from '../../util/threatLevels';
export var propTypes = {
    title: PropTypes.string,
    threatLevelCategory: PropTypes.oneOf(allThreatLevelCategories),
    policyThreatLevel: PropTypes.oneOf(allThreatLevelNumbers),
    className: PropTypes.string
};
//# sourceMappingURL=types.js.map